import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from "@reduxjs/toolkit";

import ApiClient from "#/redux/api/ApiClient";

// [sif_sist.vnos_tip_uvoza] Import entry type (UVOZ, SEME, IZVEN_KONTROLE)
const initialState = {
  list: [],
  isLoading: false,
  error: null,
};

export const fetchImportEntryTypeCodeList = createAsyncThunk(
  "importEntryTypeCodeList/fetchAll",
  async (_, { signal, rejectWithValue }) => {
    try {
      const res = await ApiClient.get("/api/sif/sist/vnosTipUvoza", {
        params: {},
        signal,
      });
      return res?.data ?? res;
    } catch (e) {
      return rejectWithValue(
        e?.response?.data ?? e?.message ?? "fetchImportEntryTypeCodeList failed"
      );
    }
  }
);

const importEntryTypeCodeListSlice = createSlice({
  name: "importEntryTypeCodeList",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchImportEntryTypeCodeList.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchImportEntryTypeCodeList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.list = Array.isArray(action.payload) ? action.payload : [];
      })
      .addCase(fetchImportEntryTypeCodeList.rejected, (state, action) => {
        state.isLoading = false;
        state.error =
          action.payload ?? action.error?.message ?? "Unknown error";
      });
  },
});

export default importEntryTypeCodeListSlice.reducer;

export const PIGS_INSERT_TYPE_LIST = createSelector(
  (state) => state.importEntryTypeCodeList.list,
  (list) =>
    list
      ?.filter((item) => item?.veljaZaPrasice === true)
      ?.sort((a, b) => (a?.numericId ?? 0) - (b?.numericId ?? 0))
);
